import { useMemo } from 'react';

export const defaultFeatures = {
  reports: true,
  excelImport: false,
  packEdit: true,
};

const useProductSearchPermissions = ({ state, voucherType, features }) => {
  const mergedFeatures = useMemo(
    () => ({ ...defaultFeatures, ...features }),
    [features],
  );

  const isLocked = state === 2 || state === 3;
  const isTransferReceipt = Number(voucherType) === 3;
  const canAdd = !isLocked && !isTransferReceipt;
  const canEditQuantity = canAdd;
  const canDelete = canAdd;
  const canEditPack = mergedFeatures.packEdit && isTransferReceipt;
  const canMutateReports = mergedFeatures.reports && !isLocked;
  const canViewReports = mergedFeatures.reports;

  return {
    mergedFeatures,
    canAdd,
    canEditQuantity,
    canDelete,
    canEditPack,
    canMutateReports,
    canViewReports,
  };
};

export default useProductSearchPermissions;
